import {createAsyncThunk} from "@reduxjs/toolkit";
import apiInstanceV2 from "../../Apis/AxiosV2";
import {EMAIL_SETTINGS_SERVICE, USER_SERVICE} from "../EndPoints";
import apiInstance from "../../Apis/Axios";

/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azpata@ibl.mx
 * Created At: 28 de 01 de 2026
 */

export const GetUserPreferencesByUserId = createAsyncThunk(
    'userPreferencesService/getUserPreferencesByUserId',
    async (userId, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .get(`${USER_SERVICE.getUserPreferencesByUserId}${userId}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

// change the time or checkbox payroll
export const UpdateUserPreferences = createAsyncThunk(
    'userPreferencesService/updateUserPreferences',
    async (params, { dispatch, getState }) => {
        const response = await apiInstance
            .put(USER_SERVICE.updateUserPreferences, params)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                return error.response;
            });
        const { data, status } = response;
        return { data, status };
    },
);

// change the time or checkbox payroll
export const CreateUserPreferences = createAsyncThunk(
    'userPreferencesService/createUserPreferences',
    async (params, { dispatch, getState }) => {
        const response = await apiInstance
            .post(USER_SERVICE.createUserPreferences, params)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                return error.response;
            });
        const { data, status } = response;
        return { data, status };
    },
);
